export enum ExportOption {
  PRESTATIECIJFER = 'Prestatiecijfers',
  TAAKCIJFER = 'Taakcijfers',
  ACTIVITEITCIJFER = 'Activiteitcijfers',
}
